import { render, staticRenderFns } from "./ShoppingListForPlan.vue?vue&type=template&id=6b5ae692&"
import script from "./ShoppingListForPlan.vue?vue&type=script&lang=js&"
export * from "./ShoppingListForPlan.vue?vue&type=script&lang=js&"
import style0 from "./ShoppingListForPlan.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports